<template>
  <div id="appBarMenu" v-if="branchData">
    <div class="d-flex align-center">
      <!-- <img src="@/assets/img/svg_icons/git-branch.svg" class="mx-2" height="25" alt="qawaem"> -->

      <div class="caption">
        <small>
          <span class="font-weight-bold">
            {{ branchData.vat_register_name || ' ' | capitalize }}
          </span>
        </small>
        <div> ( <span class="secondary--text  font-weight-bold ">
            {{ $store.state.clientID || ' ' }}</span> )
          <span class="gray5--text">
            {{ $t('tax number') | capitalize }} : {{ branchData.vat_number || ' ' }}</span>
        </div>

        <span class="gray5--text">
          {{ $t('version') | capitalize }}: {{ $store.state.app_version }}
        </span>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CompanyDetailMenu",
  computed: {
    branchData() {
      return this.$store.state.userData.user.branch_data;
    }
  },
};
</script>
